/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SystemNoteType {
  SenseHubPoultryRelease = 'SENSE_HUB_POULTRY_RELEASE',
  NewReleaseDeploymentIsPlanned = 'NEW_RELEASE_DEPLOYMENT_IS_PLANNED',
  ServiceInterruptions = 'SERVICE_INTERRUPTIONS',
  SystemIssues = 'SYSTEM_ISSUES',
  Custom = 'CUSTOM'
}
